module.exports = __webpack_public_path__ + "img/ico-bots.513c8a8a.svg";